<template>
	<div class="no-wrap has-background-white" style="width:100%; padding-bottom:50px;">
	        <div class="columns" style="padding:15px;">
				<form @submit.prevent="submit" style="display:flex; width:100%">
		            <div :class="divClass" style="padding:15px;">

		        		<div class="title" style="padding:10px 0px 20px;">
		        			<h2>{{ operationId ? 'Update' : 'Create' }} Operation</h2>
		        		</div>

						<div class="field">
							<div class="field-body">
								<label class="label">Order Id</label>
								<b-field>
									<b-autocomplete
										expanded
										v-model="form.orderId"
										:data="orders"
										placeholder="Search Order"
										@typing="query => getOrdersParent(query)"
									></b-autocomplete>
								</b-field>
							</div>
						</div>

						<div class="field">
							<div class="field-body">
								<label class="label">Operation ID</label>
								<b-field>
						            <b-input v-model="form.operationId"></b-input>
						        </b-field>
							</div>
						</div>

						<div class="field">
							<div class="field-body">
								<label class="label">Issued By</label>
								<b-field>
									<b-select expanded v-model="form.issued_by">
						                <option :value="issued_by.id" v-for="(issued_by, key) in issuedByList">
						                    {{ issued_by.name }}
						                </option>
						            </b-select>
								</b-field>
							</div>
						</div>

						<div class="field">
							<div class="field-body">
								<label class="label">Issued To</label>
								<b-field>
									<b-select expanded :disabled="!form.issued_by" v-model="form.issued_to">
						                <option :value="issued_to" v-for="(issued_to, key) in issuedToList">
						                    {{ issued_to.firm_name.name }}
						                </option>
						            </b-select>
								</b-field>
							</div>
						</div>

						<div class="field">
							<div class="field-body">
								<label class="label">Assigned To</label>
								<b-field>
									<b-select expanded :disabled="!form.issued_to" v-model="form.assigned_to">
						                <option :value="assigned_to.id" v-for="(assigned_to, key) in assignedToList">
						                    {{ assigned_to.firstName }}
						                </option>
						            </b-select>
								</b-field>
							</div>
						</div>
						
						<div class="field">
							<div class="field-body">
								<label class="label">Status</label>
						        <b-field>
						            <b-select expanded v-model="form.status">
						                <option v-for="(status, key) in statuses">
						                    {{ status }}
						                </option>
						            </b-select>
						        </b-field>
							</div>
						</div>
				        
				        <div class="field">
							<div class="field-body">
								<label class="label">Activity SubType</label>
						        <b-field>
						            <b-select expanded v-model="form.activitySubType">
						                <option v-for="(type, key) in subtypes">
						                    {{ type }}
						                </option>
						            </b-select>
						        </b-field>
							</div>
						</div>

						<div class="field">
							<div class="field-body">
								<label class="label">Required Dates</label>
								<b-field>
									<div style="display:flex;">
							            <b-datepicker style="width:50%;"
							                placeholder="Required Start"
											icon="calendar"
											v-model="form.requiredStart"
							                trap-focus>
							            </b-datepicker>
							            <b-datepicker style="width:50%;"
							                placeholder="Required Finish"
											icon="calendar"
											v-model="form.requiredFinish"
							                trap-focus>
							            </b-datepicker>
									</div>
						        </b-field>
							</div>
						</div>

						<div class="field" v-if="!form.create">
							<div class="field-body">
								<label class="label">Actual Dates</label>
								<b-field>
									<div style="display:flex;">
							            <b-datepicker style="width:50%;"
							                placeholder="Actual Start"
											icon="calendar"
											v-model="form.actualStart"
							                trap-focus>
							            </b-datepicker>
							            <b-datepicker style="width:50%;"
							                placeholder="Actual Finish"
											icon="calendar"
											v-model="form.actualFinish"
							                trap-focus>
							            </b-datepicker>
									</div>
						        </b-field>
							</div>
						</div>
						
						<div class="field">
							<div class="field-body">
								<!-- <label class="label">Description</label> -->
						        <b-field label="Description">
						            <b-input v-model="form.description" type="textarea"></b-input>
						        </b-field>
							</div>
						</div>
						<br>

						<b-field label="Claim Lines"></b-field>
						<table class="table" style="width:100%;" v-if="selected">
							<tr>
								<th style="width:50%;">Service Code</th>
								<th style="width:10%;">Quantity</th>
								<th style="width:10%;">Rate</th>
								<th style="width:10%;">Total</th>
								<th style="width:10%; text-align:center;">Note</th>
								<th style="width:10%;"></th>
							</tr>
							<template v-for="(claim, key) in filteredOrderOperationClaimLines">
							<!-- <template v-for="(claim, key) in selected.orderOperationClaimLines"> -->


								<!-- <tr v-if="claimlineRows && !claimlineRows[key]">
									<td>{{ claim.orderOperationClaimService.code }}</td>
									<td>{{ claim.quantity }}</td>
									<td>{{ claim.orderOperationClaimService.rate | numberPriceFormatterWithDollarSign }}</td>
									<td>{{ claim.orderOperationClaimService.rate * claim.quantity | numberPriceFormatterWithDollarSign }}</td>
									<td>
										<i class="fa fa-info-circle" style="cursor:pointer; font-size:20px;" :title="claim.details"></i>
									</td>
									<td  style="text-align:right;">
										<button type="button" class="button is-info" @click="editRow(claim, key)">
											<i class="fa fa-pencil"></i>
										</button>
									</td>
								</tr> -->

								<EditClaimLines
								:activityTypes="activityTypes"
								@updateActiveClaimLine="updateActiveClaimLine"
								@updateLocalClaim="updateLocalClaim"
								:claim.sync="claim"
								:form="form"
								:index="key"
								 />

							</template>
						</table>

						<!-- <table class="table" width="100%"  v-if="selected">
							<tr>
								<th>Code</th>
								<th>Description</th>
								<th>Quantity</th>
								<th>UOM</th>
								<th>Rate $</th>
								<th>Value $</th>
								<th style="text-align:right;">Action</th>
							</tr>
							<tr v-for="(claim, key) in selected.orderOperationClaimLines">
								<td>{{ claim.orderOperationClaimService.code }}</td>
								<td>
									<i class="fa fa-info-circle" style="cursor:pointer; font-size:20px;" :title="claim.details"></i>
								</td>
								<td>{{ claim.quantity }}</td>
								<td>{{ claim.orderOperationClaimService.uom }}</td>
								<td>{{ claim.orderOperationClaimService.rate | numberPriceFormatterWithDollarSign }}</td>
								<td>{{ claim.orderOperationClaimService.rate * claim.quantity | numberPriceFormatterWithDollarSign }}</td>
								<td  style="text-align:right;">
									<button type="button" class="button is-info" @click="editClicked(claim)">
										<i class="fa fa-pencil"></i>
									</button>
								</td>
							</tr>
						</table> -->

						<table class="table" style="width:100%;" v-if="form.create || edit || claimLinesList.length">
						 	<tr v-if="form.create">
						 		<th style="width:50%;">Service Code</th>
						 		<th style="width:10%;">Quantity</th>
						 		<th style="width:10%;">Rate</th>
						 		<th style="width:10%;">Total</th>
						 		<th style="width:10%;">Note</th>
						 		<th style="width:10%;"></th>
						 	</tr>
						 	<template v-for="(claimline, key) in claimLinesList">
				        		<ClaimLines 
				        		:index="key" 
								:activityTypes="activityTypes"
								:form="form"
				        		@removeClaim="removeClaim" 
				        		@updateClaimData="updateClaimData" />
						 	</template>
					
							<!-- <EditClaimLines
							:activityTypes="activityTypes"
							@removeEdit="removeEdit"
							@updateClaimLine="updateClaimLine"
							:editData.sync="editData"
							v-if="edit" /> -->


						</table>
						<div style="" v-if="!edit">
							<b-button style="float:right;" type="is-success" @click="addClaimline">Add Claim Line</b-button>
						</div>
						<br>
						<br>

						<b-field label="Notes" v-if="!$route.params.id">
				            <b-input type="textarea" v-model="notes.comment" :disabled="notes.vetted_order_activity_id != '' || !canCreateNote"></b-input>
				        </b-field>
						<hr>

						<div style="padding:20px 0px;">
							<router-link :to="{ path: '/operations'}">
								<b-button style="width:150px;">CANCEL</b-button>
							</router-link>
						 	<button class="button is-info" style="float:right; width:150px;" :disabled="formButton">SAVE</button>
						</div>

		            </div>
		            
		            <!-- <div style="width:50%; padding:15px;" v-if="!$route.params.id">
		            	<div class="title" style="padding:10px 0px;">
		        			<h2>Claim Lines</h2>
		        		</div>
						<table class="table" style="width:100%;">
						 	<tr>
						 		<td style="width:25%;">Activity Type</td>
						 		<td style="width:25%;">Service Code</td>
						 		<td style="width:10%;">Quantity</td>
						 		<td style="width:10%;">Rate</td>
						 		<td style="width:10%;">Total</td>
						 		<td style="width:10%;"></td>
						 	</tr>
						 	<template v-for="(claimline, key) in claimLinesList">
				        		<ClaimLines 
				        		:index="key" 
								:activityTypes="activityTypes"
				        		@removeClaim="removeClaim" 
				        		@updateClaimData="updateClaimData" />
						 	</template>
						</table>
						<div style="">
							<b-button style="float:right;" type="is-success" @click="addClaimline">Add Claim Line</b-button>
						</div>
		            </div> -->
				</form>
	            <div class="column is-6" v-if="$route.params.id">
	            	<form @submit.prevent="submitRight">
						<template>
							<b-tabs v-model="activeTab">

								<!-- <b-tab-item label="Claim Lines" v-if="selected">
									<table class="table" width="100%">
										<tr>
											<td>Code</td>
											<td>Description</td>
											<td>Quantity</td>
											<td>UOM</td>
											<td>Rate $</td>
											<td>Value $</td>
										</tr>
										<tr v-for="(claim, key) in selected.orderOperationClaimLines">
											<td>{{ claim.orderOperationClaimService.code }}</td>
											<td>
												<div>
													{{ claim.orderOperationClaimService.description }}
												</div>
											</td>
											<td>{{ claim.quantity }}</td>
											<td>{{ claim.orderOperationClaimService.uom }}</td>
											<td>{{ claim.orderOperationClaimService.rate | numberPriceFormatterWithDollarSign }}</td>
											<td>{{ claim.orderOperationClaimService.rate * claim.quantity | numberPriceFormatterWithDollarSign }}</td>
										</tr>
									</table>
								</b-tab-item> -->

								<b-tab-item label="Notes" v-if="selected">
									<table class="table" width="100%">
										<tr>
											<td>Date</td>
											<td>Creator</td>
											<td>Details</td>
										</tr>
										<tr v-for="(comment, key) in selected.comments">
											<td>{{ convertDate(comment.createdAt) }}</td>
											<td>{{ comment.createdBy ? comment.createdBy.fullName : '' }}</td>
											<td>{{ comment.content }}</td>
										</tr>
									</table>

									<!-- <b-field label="Vetted Note">
							            <b-select v-model="notes.vetted_order_activity_id" expanded :disabled="notes.comment != ''">
							                <option v-for="(note, key) in notes.vettedNotes">
							                    {{ note.shortText }}
							                </option>
							            </b-select>
							        </b-field> -->
							        <b-field label="Description">
							            <b-input type="textarea" v-model="notes.comment" :disabled="notes.vetted_order_activity_id != '' || !canCreateNote"></b-input>
							        </b-field>
	       							<b-checkbox v-model="notes.is_sensitive" :disabled="!canCreateNote">Confidential</b-checkbox>
									
		            				<button class="button is-info" style="float:right; width:150px;" v-if="selected && canCreateNote">Save</button>
					            </b-tab-item>

								<b-tab-item label="Documents" v-if="selected">
								</b-tab-item>

		            		</b-tabs>
						</template>
	            		
	            	</form>
	            </div>
	        </div>
    </div>
</template>

<script>
	import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
	import { OrderOperationClaimLineService } from "@/services/orderOperationClaimLine.service";
	import { VettedStatementService } from "@/services/vettedStatement.service";
	import { OrderService } from "@/services/order.service";
	import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
	import debounce from "lodash/debounce";
	import BaseTable from "@/components/partials/BaseTable";
	import BaseSelect from "@/components/partials/BaseSelect";
	import { FirmService } from "@/services/firm.service";
	import { OrderOperationService } from "@/services/orderOperation.service";
	import { AssociatedService } from "@/services/associated.service";
	import { UserService } from "@/services/user.service";
	import { DateFormat } from "@/helpers/date-format";

	import ClaimLines from "./claimLines";
	import EditClaimLines from "./editClaimLines";

	import moment from "moment";
	export default {
		orderOperationService: OrderOperationService,
	    vettedStatementService: VettedStatementService,
	 	orderOperationClaimService: OrderOperationClaimServiceService,
	    firmService: FirmService,
	  	components: {
	    	BaseTable, BaseSelect, ClaimLines, EditClaimLines
	  	},
	    data: () => ({
	    	edit: null,
	    	editData: {
    			code: null,
    			quantity: 1,
    			rate: 0,
    			notes: null,
	    	},
	    	operationId: null,
	    	activeTab: 0,
	    	modalData: false,
	    	selected: null,
	    	statuses: [ 'DRAFT', 'PROPOSED', 'OUTSTANDING', 'COMPLETED', 'INVOICED' ],
	    	subtypes: [ 'QUOTE', 'OPERATION', 'INVOICE' ],
	    	form: {
	    		id: null,
	    		orderId: null,
	    		operationId: null,
	    		status: null,
	    		activitySubType: null,
	    		requiredStart: null,
	    		requiredFinish: null,
	    		actualStart: null,
	    		actualFinish: null,
	    		description: null,
	    		create: null,
	    		issued_by: null,
	    		issued_to: null,
	    		assigned_to: null,
	    		firm_firm_id: null,
	    	},
	    	notes: {
	    		vetted_order_activity_id: '',
	    		comment: '',
	    		is_sensitive: false,
	    		vettedNotes: [],
	    		note: '',
	    	},
	    	claim: {
	    		activity_type: null,
	    		details: '',
	    		quantity: 1,
	    		rate: 0,
	    		orderOperationClaimServiceId: null,
	    		code: null,
	    	},

	    	orders: [],
	    	serviceCategory: "",
	    	issuedByList: [],
	    	issuedToList: [],
	    	assignedToList: [],
	    	selectedIssuedTo: null,
		    params: {
		    	includes: 'comments,comments.createdBy,orderOperationClaimLines'
		    },
		    activityTypes: [],
		    serviceCodes: [],


		    claimLinesList: [
		    	// {
	    		// 	code: null,
	    		// 	quantity: 1,
	    		// 	rate: 0,
	    		// 	total: 0,
	    		// 	notes: null,
		    	// }
		    ],
		    activeEditClaimLine: [],
		    formButton: false,

	    }),
	    computed: {
	    	filteredOrderOperationClaimLines() {
	    		if (this.selected.orderOperationClaimLines.length && this.form.issued_to) {
	    			return this.selected.orderOperationClaimLines.filter(element => {
	    				if (element.orderOperationClaimService) {
	    					return element.orderOperationClaimService.firmId == this.form.issued_to.firm_name.id
	    				}
	    			});
	    			// return this.selected.orderOperationClaimLines.filter(element => element.orderOperationClaimService.firmId == this.selectedIssuedTo);
	    		}
	    		return [];
	    	},
		    total() {
		    	return this.claim.rate * this.form.quantity;
		    },
		    columns() {
		        let columns = [];
		        columns.push({field: "orderId", label: "Order ID"});
		        columns.push({field: "operationId", label: "Operation ID"});
		        columns.push({field: "status", label: "Status"});
		        columns.push({field: "", label: "", meta: {
		            rowSlot: "rowAction"
		        }});
		        return columns;
		    },
		    divClass() {
		    	return {
		    		'full-div': this.$route.params.id ? true : false,
		    		'half-div': this.$route.params.id ? false : true,
		    	}
		    },

		    canCreateNote() {
        		return this.$store.getters["Auth/hasFirmPermission"]("can comment on operations");
		    }

		},
		watch: {
			'form.issued_by'(id) {
				if (id) {
					this.issuedToList = [];
					AssociatedService.getAssociated({ id: id }).then(response => {
						this.issuedToList = response;
						if (this.selectedIssuedTo) {
							Object.entries(response).forEach(([key, value]) => {
								if (value.child_id == this.selectedIssuedTo) {
									this.form.issued_to = value;
								}
							});
						}
					});
				}
			},
			'form.issued_to'(issued_to) {
				if (issued_to) {
					this.form.firm_firm_id = issued_to.id
					this.assignedToList = [];
					UserService.all({ firmId: issued_to.child_id }).then(response => {
						this.assignedToList = JsonDenormalizer.denormalize(response);
					});
				}
			},
			'claim.activity_type'(value) {
				OrderOperationClaimServiceService.all({category: value}).then(response => {
					this.serviceCodes = JsonDenormalizer.denormalize(response);
				});
			},
			'claim.code'(code) {
				this.claim.orderOperationClaimServiceId = code.id;
				this.claim.rate = code.rate;
			},

			// activeEditClaimLine(value) {
			// 	alert(value);
			// }
	
		},
		methods: {
			updateActiveClaimLine(index, value) {
				this.activeEditClaimLine[index] = !value;
				this.$nextTick(() => {
					this.formButton = this.activeEditClaimLine.filter(element => element == true).length ? true : false;
				});
			},
			updateLocalClaim(index, newValue) {
				// console.log(newValue);
				this.selected.orderOperationClaimLines[index] = newValue;
			},
			updateClaimLine() {
				let data = {
					orderOperationClaimServiceId: this.editData.code,
					details: this.editData.notes,
					quantity: this.editData.quantity
				};
				OrderOperationClaimLineService.updateClaimLine(this.edit.id, data).then(response => {
					this.getOperation();
					this.edit = null;
					this.$buefy.toast.open({
			          message: "Success",
			          type: "is-info",
			          position: "is-top-right"
			        });
				});
			},
			removeEdit() {
				this.edit = null;
			},
			editClicked(claim) {
				this.edit = claim;
				this.claimLinesList = [];
			},
			claimData() {
				return {
		    		details: this.claim.details,
		    		quantity: this.claim.quantity,
		    		rate: this.claim.rate,
		    		orderOperationClaimServiceId: this.claim.orderOperationClaimServiceId,
				};
			},
			convertDate(date) {
				return DateFormat.toLocalDateAndTime(date)
			},
			openModal(row = null) {
				this.selected            = row;
				this.modalData           = true;
				this.form.id             = row ? row.id : 0;
				this.form.orderId        = row ? row.orderId : null;
				this.form.create         = row ? false : true;
				this.form.operationId    = row ? row.operationId : null;
				this.form.status         = row ? row.status : null;
				this.form.description    = row ? row.description : null;
				this.form.requiredStart  = row && row.requiredStart ? new Date(moment(row.requiredStart).format("MM/DD/YYYY")) : null;
				this.form.requiredFinish = row && row.requiredFinish ? new Date(moment(row.requiredFinish).format("MM/DD/YYYY")) : null;
				this.form.actualStart    = row && row.actualStart ? new Date(moment(row.actualStart).format("MM/DD/YYYY")) : null;
				this.form.actualFinish   = row && row.actualFinish ? new Date(moment(row.actualFinish).format("MM/DD/YYYY")) : null;

				// console.log(moment(row.requiredStart).add(1, 'minutes'));
				// console.log(moment(row.requiredStart).utcOffset(row.requiredStart));

				// this.form.requiredStart  = row && row.requiredStart ? new Date(moment(row.requiredStart, moment.tz.guess()).format("MM/DD/YYYY")) : null;
				// this.form.requiredFinish = row && row.requiredFinish ? new Date(moment(row.requiredFinish, moment.tz.guess()).format("MM/DD/YYYY")) : null;
				// this.form.actualStart    = row && row.actualStart ? new Date(moment(row.actualStart, moment.tz.guess()).format("MM/DD/YYYY")) : null;
				// this.form.actualFinish   = row && row.actualFinish ? new Date(moment(row.actualFinish, moment.tz.guess()).format("MM/DD/YYYY")) : null;

				FirmService.children().then(response => {
					this.issuedByList = JsonDenormalizer.denormalize(response);
				});
				if (row) {
					if (row.firm_firm_id) {
						this.findAssociated(row);
					}
				} else {
					// this.issuedByList = [];
					this.issuedToList = [];
					this.assignedToList = [];
					this.form.issued_by = '';
					this.form.issued_to = '';
					this.form.assigned_to = '';
					this.activeTab = 0;
				}

				// this.form.issued_by    = row ? row.issued_by : null;
				// this.form.issued_to    = row ? row.issued_to : null;
				// this.form.assigned_to    = row ? row.assigned_to : null;
			},
			findAssociated(row) {
				FirmService.findAssociated({ id: row.firm_firm_id }).then(response => {
					if (response) {
						this.selectedIssuedTo = response.child_id;
						this.form.issued_by = response.parent_id;
						this.form.assigned_to = row.child_firm_person_id;
					}
				});
			},
			getOrdersParent: debounce(function(search) {
	      		let orders = [];
				OrderService.all({ search }).then(response => {
					response.data.forEach(order => {
						orders.push(order.orderId || order.id);
			        });
					this.orders = orders;
			    });
			}, 500),

			// submit() {
			// 	if (this.activeTab === 0) {
			// 		OrderOperationService.createOperation(this.form).then(response => {
			// 			this.fetch();
			// 	        this.$buefy.toast.open({
			// 	          message: "Success",
			// 	          type: "is-info",
			// 	          position: "is-top-right"
			// 	        });
			// 	        this.modalData = false;
			// 		});
			// 	} else if (this.activeTab === 1) {
			// 		OrderOperationService.createComment(this.selected.id,  this.notes ).then(response => {
			// 			this.fetch();
			// 			this.$buefy.toast.open({
			// 	          message: "Success",
			// 	          type: "is-info",
			// 	          position: "is-top-right"
			// 	        });
			// 	        this.modalData = false;
			// 	        this.resetNote();
			// 		});
			// 	} else {
			// 		OrderOperationClaimLineService.create(this.selected.id, this.claimData()).then(response => {
			// 	        this.fetch();
			// 			this.$buefy.toast.open({
			// 	          message: "Success",
			// 	          type: "is-info",
			// 	          position: "is-top-right"
			// 	        });
			// 	        this.modalData = false;
			// 		});
			// 	}
			// },
			onInput(key, val) {
				this.notes[key] = val;
			},
			resetNote() {
				this.notes.vetted_order_activity_id = '';
				this.notes.comment = '';
				this.notes.is_sensitive = false;
			},
			resetClaim() {
				this.notes.vetted_order_activity_id = '';
				this.notes.comment = '';
				this.notes.is_sensitive = false;
			},
			getIssuedBy() {
				FirmService.children().then(response => {
					this.issuedByList = JsonDenormalizer.denormalize(response);
				});
			},
			getActivityTypes() {
				OrderOperationClaimServiceService.listCategories().then(response => {
					this.activityTypes = JsonDenormalizer.denormalize(response);
				});
			},
			getVettedNotes() {
				VettedStatementService.all().then(response => {
					this.notes.vettedNotes = JsonDenormalizer.denormalize(response);
				});
			},

			addClaimline() {
				this.claimLinesList.push({ 
	    			code: null,
	    			quantity: 1,
	    			rate: 0,
	    			total: 0,
	    			notes: null,
		    	});
			},
			removeClaim(index) {
				// console.log(index);
				// console.log(this.claimLinesList.splice(index+1, 1));
				this.claimLinesList.splice(index, 1);
			},
			updateClaimData(data) {
				this.claimLinesList[data.index][data.type] = data.value;
			},

			submit() {

				if (! this.operationId) {
					OrderOperationService.hybridCreate({ 
						operation: this.form, 
						claimLines: this.claimLinesList, 
						note: {note: this.notes.comment, vetted_order_activity_id: this.notes.vetted_order_activity_id} 
					}).then(response => {
						this.$buefy.toast.open({
				          message: "Success",
				          type: "is-info",
				          position: "is-top-right"
				        });
						let data = JsonDenormalizer.denormalize(response);
				        this.operationId = data.id;
				        this.form.id = data.id;
				        this.form.create = false;
						this.selected = data;
				        this.$router.push(`/operation/update/${data.id}`) 
						this.claimLinesList = [];
				        this.notes.comment = '';
					});
				}
				else {
					OrderOperationService.hybridCreate({ 
						operation: this.form, 
						claimLines: this.claimLinesList, 
					}).then(response => {
						this.$buefy.toast.open({
				          message: "Success",
				          type: "is-info",
				          position: "is-top-right"
				        });
						let data = JsonDenormalizer.denormalize(response);
						this.selected = data;
						// this.claimLinesList = [{ 
			   //  			code: null,
			   //  			quantity: 1,
			   //  			rate: 0,
			   //  			total: 0,
			   //  			notes: null,
				  //   	}];
						this.claimLinesList = [];
					});

					// OrderOperationService.createOperation({ operation: this.form, claimLines: this.claimLinesList }).then(response => {
				 //        this.$buefy.toast.open({
				 //          message: "Success",
				 //          type: "is-info",
				 //          position: "is-top-right"
				 //        });
				 //        let data = JsonDenormalizer.denormalize(response);
					// 	this.selected = data;
					// });
				}
			},

			submitRight() {
				if (this.activeTab === 0) {
					// OrderOperationService.createMultipleClaimLine(this.selected.id,  {claimLines: this.claimLinesList} ).then(response => {
					// 	this.getOperation();
					// 	this.$buefy.toast.open({
				 //          message: "Success",
				 //          type: "is-info",
				 //          position: "is-top-right"
				 //        });
				 //     //    this.claimLinesList = [{
			  //   		// 	code: null,
			  //   		// 	quantity: 1,
			  //   		// 	rate: 0,
			  //   		// 	total: 0,
			  //   		// 	notes: null,
				 //    	// }];
				 //        this.claimLinesList = [];
					// });
					let data = {
						is_vetted_order_activity: this.notes.is_vetted_order_activity,
						comment: this.notes.comment,
						is_sensitive: this.notes. is_sensitive
					};
					OrderOperationService.createNewComment(this.selected.id,  data ).then(response => {
						this.getOperation();
						this.$buefy.toast.open({
				          message: "Success",
				          type: "is-info",
				          position: "is-top-right"
				        });
				        this.resetNote();
					});
					// OrderOperationService.createComment(this.selected.id,  data ).then(response => {
					// 	this.getOperation();
					// 	this.$buefy.toast.open({
				 //          message: "Success",
				 //          type: "is-info",
				 //          position: "is-top-right"
				 //        });
				 //        this.resetNote();
					// });
				} else {
				}
			},

			getOperation() {
				this.operationId = this.$route.params.id;
				OrderOperationService.find(this.$route.params.id, this.params).then(response => {
					let data = JsonDenormalizer.denormalize(response);
					this.selected = data;
					
					if (! data.orderOperationClaimLines.length) {
						this.resetClaimlineValue();
					}

					this.modalData            = true;
					this.form.id              = data.id;
					this.form.orderId         = data.orderId;
					this.form.create          = false;
					this.form.operationId     = data.operationId;
					this.form.status          = data.status;
					this.form.activitySubType = data.activitySubType;
					this.form.description     = data.description;
					this.form.requiredStart   = data.requiredStart ? new Date(moment(data.requiredStart).format("MM/DD/YYYY")) : null;
					this.form.requiredFinish  = data.requiredFinish ? new Date(moment(data.requiredFinish).format("MM/DD/YYYY")) : null;
					this.form.actualStart     = data.actualStart ? new Date(moment(data.actualStart).format("MM/DD/YYYY")) : null;
					this.form.actualFinish    = data.actualFinish ? new Date(moment(data.actualFinish).format("MM/DD/YYYY")) : null;

					this.findAssociated(data);
				});
			},
			resetClaimlineValue() {
				this.claimLinesList = [{ 
	    			code: null,
	    			quantity: 1,
	    			rate: 0,
	    			total: 0,
	    			notes: null,
		    	}];
			}

		},
		mounted() {
			this.getIssuedBy();
			this.getVettedNotes();
			this.getActivityTypes();
			if (this.$route.params.id) {
				this.getOperation();
			}else {
				this.claimLinesList = [{ 
	    			code: null,
	    			quantity: 1,
	    			rate: 0,
	    			total: 0,
	    			notes: null,
		    	}];
				this.form.create = true;
			}
		}
	};
</script>

<style scoped>
	.field-body label {
		width: 150px;
	}
	.half-div {
		width: 50%;
	}
	.full-div {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/pages/Operations/form.vue